export const lessonReportsSelector = (state: any) => state.lessonReports;
